import React from "react";

function CalenderIcon({ color = "#52a8f2", className }: IconPropsType) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="178.359"
      height="256.297"
      className={className}
      viewBox="0 0 178.359 256.297"
    >
      <g
        id="Calender_icons"
        data-name="Calender icons"
        transform="translate(-1681.516 -1226.063)"
      >
        <path
          id="calender"
          d="M15.341,38.33V107.3H107.3V38.33ZM99.628,15.341h15.329a7.238,7.238,0,0,1,7.66,7.66v91.956a7.238,7.238,0,0,1-7.66,7.66H7.672a7.238,7.238,0,0,1-7.66-7.66V23a7.238,7.238,0,0,1,7.66-7.66H23V7.672a7.238,7.238,0,0,1,7.66-7.66,7.238,7.238,0,0,1,7.66,7.66v7.66H84.261V7.672a7.665,7.665,0,1,1,15.329,0ZM68.979,91.968H53.65V76.639H68.979ZM91.968,68.979H76.639V53.65H91.968Zm-22.989,0H53.65V53.65H68.979Zm-22.513,0H31.174V53.65H46.466Z"
          transform="matrix(0.946, 0.326, -0.326, 0.946, 1743.926, 1226.064)"
          fill={color}
          fill-rule="evenodd"
          opacity="0.5"
        />
        <path
          id="calender-2"
          data-name="calender"
          d="M9.969,24.909V69.73H69.73V24.909ZM64.745,9.969h9.962a4.7,4.7,0,0,1,4.978,4.978v59.76a4.7,4.7,0,0,1-4.978,4.978H4.985A4.7,4.7,0,0,1,.007,74.708V14.947A4.7,4.7,0,0,1,4.985,9.969h9.962V4.985A4.7,4.7,0,0,1,19.925.007,4.7,4.7,0,0,1,24.9,4.985V9.963H54.759V4.985a4.981,4.981,0,1,1,9.962,0Zm-19.918,49.8H34.865V49.805h9.962Zm14.94-14.94H49.805V34.865h9.962Zm-14.94,0H34.865V34.865h9.962Zm-14.631,0H20.259V34.865H30.2Z"
          transform="translate(1681.518 1406.565) rotate(-18)"
          fill="#f2e30c"
          fill-rule="evenodd"
          opacity="0.4"
        />
        <path
          id="calender-3"
          data-name="calender"
          d="M5.471,13.671v24.6h32.8v-24.6Zm30.063-8.2H41A2.582,2.582,0,0,1,43.734,8.2V41A2.582,2.582,0,0,1,41,43.734H2.735A2.582,2.582,0,0,1,0,41V8.2A2.582,2.582,0,0,1,2.735,5.471H8.2V2.735A2.582,2.582,0,0,1,10.935,0a2.582,2.582,0,0,1,2.732,2.732V5.467H30.053V2.735a2.734,2.734,0,0,1,5.468,0ZM24.6,32.8H19.135V27.334H24.6Zm8.2-8.2H27.334V19.135H32.8Zm-8.2,0H19.135V19.135H24.6Zm-8.03,0H11.118V19.135h5.454Z"
          transform="translate(1821.323 1392.855) rotate(30)"
          fill={color}
          fill-rule="evenodd"
          opacity="0.6"
        />
      </g>
    </svg>
  );
}

export default CalenderIcon;
type IconPropsType = {
  color?: string;
  className?: string;
};
